import { Box } from '@material-ui/core';
import React from 'react';
import useStyles from '../../QuickActions/styles';

const VehicleInputMethodTabs = ({
  tabToLabelMap,
  labelActive,
  setLabelActive,
}) => {
  const classes = useStyles();

  if (Object.keys(tabToLabelMap).length < 2) return null;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-evenly"
      flexWrap="wrap"
    >
      {Object.entries(tabToLabelMap).map(([tab, label]) => (
        <Box
          key={tab}
          className={`${classes.tabLabel} ${
            labelActive === tab ? classes.tabActive : ''
          }`}
          onClick={() => setLabelActive(tab)}
        >
          {label}
        </Box>
      ))}
    </Box>
  );
};

export default VehicleInputMethodTabs;
